import { createPath } from '../_utils/createPath';

export const PROFILE_QUERY_KEYS = {
  getMe: ['get', 'me'],
};

export const profile = {
  getMe: createPath('/me'),
};
